module.exports = __webpack_public_path__ + "img/cover.c923530e.jpg";